import { LocalizationService } from '@abp/ng.core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FilterPanelEditorConfigurationModel } from 'src/ca-shared/filter-panel/models/filter-panel-editor-configuration.model';
import { FilterPanelEditorComponent } from 'src/ca-shared/filter-panel/models/filter-panel-editor.component';
import { SelectorComponent } from 'src/ca-shared/selector/selector.module';
import { QuestionDto } from 'src/core/models/quality-management/question.dto';
import { Operators } from 'src/core/models/request/operator.enum';
import { QuestionSelectionConfigurationModel } from '../models/question-selection-configuration-model';
import { FilterItemDto } from 'src/core/models/request/filter-item.dto';

@Component({
    selector: 'ca-question-selection-panel',
    templateUrl: './question-selection-panel.component.html',
    styleUrls: ['./question-selection-panel.component.scss'],
    standalone: false
})
export class QuestionSelectionPanelComponent extends FilterPanelEditorComponent implements OnInit {
  actualConfig: QuestionSelectionConfigurationModel;

  _value: QuestionDto[];
  questionSelectorOptions: any;

  @ViewChild(SelectorComponent, { read: SelectorComponent })
  questionSelector: SelectorComponent;
  filters: FilterItemDto[] = [];

  set config(value: FilterPanelEditorConfigurationModel) {
    this.actualConfig = value as QuestionSelectionConfigurationModel;
  }

  get config(): FilterPanelEditorConfigurationModel {
    return this.actualConfig;
  }

  set value(value: any) {
    this.editorForm.patchValue({
      editor: value,
    });
  }

  get value(): any {
    return this._value;
  }

  constructor(
    private localizationService: LocalizationService,
    private operators: Operators,
    protected fb: FormBuilder
  ) {
    super(fb);

    this.editorForm.valueChanges.subscribe(val => {
      this._value = val.editor;
      this.onChange();
    });
  }

  ngOnInit(): void {
    this.questionSelectorOptions = {
      pageSize: 5,
      queryOperator: this.operators.Contains,
      queryField: 'quickSearchTerm',
      emptyText: this.localizationService.instant('::SelectQuestion'),
      multiple: false,
      url: 'api/app/quality/form-questions',
      currentPage: 1,
      showSelections: false,
      showClearSelections: false,
      showClearSelectionLink: true,
      selectorPosition: 'Top',
      filters: this.filters,
    };
  }

  reload(): void {
    this.innerLoad();
  }

  reset(): void {
     this.value = null;
  }

  init() {
    super.init();

    if (this.actualConfig.autoLoad) {
      this.innerLoad();
    }
  }
  
  autoSelectFirstItem(): void {}

  private innerLoad() {
    const filters: FilterItemDto[] = [];

    if (this.extraData.versionId) {
      filters.push({
        field: 'versionId',
        operator: this.operators.Equals,
        value: this.extraData.versionId,
      });

      if (this.extraData.formId) {
        filters.push({
          field: 'formId',
          operator: this.operators.Equals,
          value: this.extraData.formId,
        });
      }

      if (this.extraData.sectionId) {
        filters.push({
          field: 'sectionId',
          operator: this.operators.Equals,
          value: this.extraData.sectionId,
        });
      }

      this.questionSelector.setFilters(filters);
      this.questionSelector.refresh();
    }
  }
}
